import { Button } from '@/components/Button/Button';
import { WIRE_STATUS_DB } from '@/const/wire';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { ConfirmModal } from '@/components/ConfirmModal/ConfirmModal';
import { showSnackbarResponseError } from '@/helpers/helpers';
import { changeWireStatus } from '@/bundle/_OrgAdmin/pages/InboundWire/api/api';

type CancelWireType = {
  id: string;
};

export const CancelWire = ({ id }: CancelWireType) => {
  const queryClient = useQueryClient();

  const [isOpenModal, setIsOpenModal] = useState(false);

  const { mutate: mutateCancelWire, isPending: isPendingCancelWire } = useMutation({
    mutationKey: ['cancel_wire'],
    mutationFn: () => {
      return changeWireStatus(id, WIRE_STATUS_DB.CANCELLED);
    },
    onSuccess(response) {
      if (response?.error) {
        return showSnackbarResponseError(response?.error);
      }

      amplitudeService.logEvent(AMPLITUDE_EVENTS.CancelInboundWireSuccess);

      queryClient.setQueryData(['inbound_wire', id], response);
    },
    onSettled() {
      setIsOpenModal(false);
    },
  });

  const openCancelWireDialog = () => {
    setIsOpenModal(true);

    amplitudeService.logEvent(AMPLITUDE_EVENTS.CancelInboundWireStartRedirect);
  };

  return (
    <>
      <Button variant='secondary' width={160} mobileStretch onClick={openCancelWireDialog}>
        Cancel Wire
      </Button>

      <ConfirmModal
        isOpen={isOpenModal}
        header='Cancel Wire'
        isLoading={isPendingCancelWire}
        body='You will not be able to view this wire once you cancel.'
        onClose={() => setIsOpenModal(false)}
        onConfirm={mutateCancelWire}
      />
    </>
  );
};
